export default "__VITE_ASSET__a9rk19ne__"